import { useEffect, useContext } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import MainContext from "../../context/main/mainContext";

export default function CompanyInfo({
  inputClasses, labelClasses, helperClasses, isQuote,
}) {
  const { register, setValue, formState: { errors } } = useFormContext();
  const [companyName, clientEmail, clientName] = useWatch({
    name: ["companyName", "billing.clientEmail", "billing.clientName"],
  });

  const { team } = useContext(MainContext);

  useEffect(() => {
    if (team?.companyName) {
      setValue("companyName", team?.companyName);
    }
  }, [team?.companyName]);

  return (
    <div className="flex flex-col gap-2">
      <div>
        <label htmlFor="company-name" className={labelClasses}>
          Company name
        </label>
        <input
          {...register("companyName", { required: "Company name is required" })}
          type="text"
          value={companyName}
          onChange={(e) => setValue("companyName", e.target.value, { shouldDirty: true, shouldValidate: true })
          }
          placeholder="e.g. Popl, Inc."
          className={inputClasses}
        />
        <div id="company-name-help" className={helperClasses}>
          The legal company name for invoicing.
        </div>
        {errors?.companyName && (
          <p className="text-xs text-red-600 mt-1">{errors?.companyName?.message}</p>
        )}
      </div>
      {isQuote && (
        <>
          <div>
            <label htmlFor="client-name" className={labelClasses}>
              Client Name
            </label>
            <input
              {...register("billing.clientName")}
              type="text"
              value={clientName}
              onChange={(e) => setValue("billing.clientName", e.target.value)}
              placeholder="e.g. Elon Musk"
              className={inputClasses}
            />
            <div id="client-name-help" className={helperClasses}>
              Client name for invoicing
            </div>
          </div>
          <div>
            <label htmlFor="client-email" className={labelClasses}>
              Client Email
            </label>
            <input
              {...register("billing.clientEmail")}
              type="text"
              value={clientEmail}
              onChange={(e) => setValue("billing.clientEmail", e.target.value)}
              placeholder="e.g. test@example.com"
              className={inputClasses}
            />
            <div id="client-email-help" className={helperClasses}>
              The legal company name for invoicing.
            </div>
          </div>
        </>
      )}
    </div>
  );
}
